import request from '@/utils/request'

// 获取轮播图
export function getBannerList() {
  return request({ url: '/kws/banner/listPublic', method: 'get' })
}
// 获取板块类型列表（动态导航菜单用）
export function getSectionTypeList() {
  return request({ url: '/kws/sectionType/listPublic', method: 'get' })
}
// 获取板块内容（按类型 - 扁平）
export function getSectionItemList(sectionType) {
  return request({ url: '/kws/sectionItem/listPublic', method: 'get', params: { sectionType } })
}
// 获取分组后的板块内容（parent_id=0是二级标题，children是子卡片）
export function getSectionItemGrouped(sectionType) {
  return request({ url: '/kws/sectionItem/listGrouped', method: 'get', params: { sectionType } })
}
// 获取设备列表
export function getEquipmentList() {
  return request({ url: '/kws/equipment/listPublic', method: 'get' })
}
// 获取证书图片
export function getCertificateImgList() {
  return request({ url: '/kws/certificateImg/listPublic', method: 'get' })
}
// 获取网站配置
export function getSiteConfigList() {
  return request({ url: '/kws/siteConfig/listPublic', method: 'get' })
}
// 获取公告列表(通用，可传noticeType过滤)
export function getNoticeList(params) {
  return request({ url: '/system/notice/listPublic', method: 'get', params: { status: 0, ...params } })
}
// 获取新闻列表 (noticeType=1)
export function getNewsList(params) {
  return getNoticeList({ noticeType: '1', ...params })
}
// 获取计量专栏列表 (noticeType=2)
export function getMeasureList(params) {
  return getNoticeList({ noticeType: '2', ...params })
}
// 获取公告详情(新闻/计量专栏通用)
export function getNoticeDetail(id) {
  return request({ url: '/system/notice/publishInfo/' + id, method: 'get' })
}
// 证书查询
export function searchCertificate(keyword) {
  return request({ url: '/kws/certificate/search', method: 'get', params: { keyword } })
}
